import { notifications } from "@mantine/notifications";

type Variant = "success" | "error" | "info";

const classify = (message: string): Variant => {
  const m = message.toLowerCase();
  if (/(fail|error|invalid|incorrect|wrong|please |must )/i.test(m)) return "error";
  if (/(success|complete|resent|submitted|saved|approved|uploaded|denied)/i.test(m))
    return "success";
  return "info";
};

const colorFor = (variant: Variant): string => {
  switch (variant) {
    case "success":
      return "green";
    case "error":
      return "red";
    default:
      return "blue";
  }
};

const titleFor = (variant: Variant): string => {
  switch (variant) {
    case "success":
      return "Success";
    case "error":
      return "Error";
    default:
      return "Notice";
  }
};

export const notify = (
  message: string,
  options?: { variant?: Variant; title?: string },
): void => {
  const variant = options?.variant ?? classify(message);
  notifications.show({
    title: options?.title ?? titleFor(variant),
    message,
    color: colorFor(variant),
    withBorder: true,
    radius: "md",
  });
};

export const showAlert = (message: string): void => notify(message);
export const notifySuccess = (message: string, title?: string): void =>
  notify(message, { variant: "success", title });
export const notifyError = (message: string, title?: string): void =>
  notify(message, { variant: "error", title });
export const notifyInfo = (message: string, title?: string): void =>
  notify(message, { variant: "info", title });
